import { ADModalBody, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { CustomGroup } from "./GroupedLayerControl";
import { Fragment } from "react/jsx-runtime";
import { Localization } from "@viamap/viamap2-common";
import { HiOutlineChevronUp } from "react-icons/hi";


export function FaveLayerEditor(props: { editingLayers: CustomGroup[], callBack: (group: CustomGroup) => void }) {

   if (props.editingLayers?.length === 0 || !props.editingLayers) {
      return null;
   }

   return (
      <AdvancedDragModal variant={"Small"} title={Localization.getText("Favorite layer info")}
         onClose={() => props.editingLayers.forEach((group) => props.callBack(group))}
      >
         <ADModalBody>
            {props.editingLayers.map((group) => {
               return (
                  <Fragment key={group.uuid}>
                     <div className="FeatureLayerEditor_Single FLE-S">
                        <div className="FLE-Head" >
                           <span>{group.title}</span>
                           <div onClick={() => {
                              props.callBack(group)
                           }} className="FLE-close"><HiOutlineChevronUp /></div>
                        </div>
                        <div className="FLE-Body" >
                           {group.layers.map((layer) => {
                              return (
                                 <div key={layer} className="FLE-InputGroup" >
                                    <div className="FLE-InputTitle">{layer}</div>
                                 </div>
                              )
                           })}
                        </div>
                     </div>
                  </Fragment>
               )
            })}
         </ADModalBody >
      </AdvancedDragModal>
   )
}